/* HELIAON custom COD form, Phase 1 (PL market)  Iteration 4
   - phone: country-code select + confirmation checkbox (PL=9 digits, others 7-12)
   - email optional
   - consent removed
   - trust-top (photos + stars + text) rendered from CFG.settings.trust_top
   - upsell row from CFG.upsells; picks add extra line items
   - package protection checkbox adds CFG.settings.protection.price to totals
   - downsell: unlimited (no session guard), NO × close button, backdrop/ESC = jiggle
*/
// HLN-COD-RESPONSIVE v1 — inject viewport-aware modal styles BEFORE the form ever opens.
(function(){
  try {
    var css = '#heliaon-cod-root{overflow:hidden}'+
              '#heliaon-cod-modal{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;padding:12px;box-sizing:border-box;overflow:hidden}'+
              '.hlc-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:1}'+
              '.hlc-panel{position:relative;z-index:2;background:#F8F5EF;border-radius:14px;max-width:520px;width:100%;max-height:calc(100vh - 24px);max-height:calc(100dvh - 24px);overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;box-shadow:0 20px 60px rgba(0,0,0,.35);padding:20px}'+
              'body.hlc-modal-open{overflow:hidden;position:fixed;left:0;right:0;top:0;bottom:0;width:100%}'+
              '@media(max-width:600px){.hlc-panel{padding:14px;max-height:calc(100vh - 16px);max-height:calc(100dvh - 16px);border-radius:10px}#heliaon-cod-modal{padding:8px}}';
    var s = document.createElement('style');
    s.id = 'hln-cod-responsive';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  } catch(e){}
})();
(function () {
  'use strict';
  var bootEl = document.getElementById('heliaon-cod-boot');
  var countriesEl = document.getElementById('heliaon-cod-countries');
  if (!bootEl || !countriesEl) return;
  var CFG, COUNTRIES;
  try { CFG = JSON.parse(bootEl.textContent || '{}')
var ACC=(getComputedStyle(document.documentElement).getPropertyValue('--hln-accent')||'').trim()||'#8A2E3E';; } catch (e) { console.warn('[hlc] bad boot json', e); return; }
  try { COUNTRIES = JSON.parse(countriesEl.textContent || '{}'); } catch (e) { console.warn('[hlc] bad countries json', e); return; }
  // HLN-COD-MARKETS v1 — the section can ship to 1+ countries (e.g. GR + CY on the Greek market).
  // Each market entry: { iso, label, phone_cc, shipping_fee, cod_fee }.
  var MARKETS = Array.isArray(CFG.markets) && CFG.markets.length ? CFG.markets : null;
  var COUNTRY_CODE = ((CFG.market || (CFG.language === 'el' ? 'gr' : CFG.language) || 'pl') + '').toUpperCase();
  if (!MARKETS) {
    // Legacy fallback: derive from CFG.market
    MARKETS = [{
      iso: COUNTRY_CODE,
      label: (COUNTRIES[COUNTRY_CODE] && COUNTRIES[COUNTRY_CODE].label) || COUNTRY_CODE,
      phone_cc: CFG.phone_cc_default || (COUNTRIES[COUNTRY_CODE] && COUNTRIES[COUNTRY_CODE].phone && COUNTRIES[COUNTRY_CODE].phone.prefix) || '+30',
      shipping_fee: (CFG.settings && CFG.settings.pricing && CFG.settings.pricing.shipping_fee) || 0,
      cod_fee:      (CFG.settings && CFG.settings.pricing && CFG.settings.pricing.cod_fee) || 0
    }];
  }
  // Normalise ISO to uppercase
  MARKETS.forEach(function(m){ m.iso = String(m.iso || '').toUpperCase(); });
  var currentMarket = MARKETS[0]; // default = first market
  var C = COUNTRIES[currentMarket.iso] || COUNTRIES[COUNTRY_CODE] || COUNTRIES['PL'];
  if (!C) return;

  var root = document.getElementById('heliaon-cod-root');
  var modal = document.getElementById('heliaon-cod-modal');
  var form = document.getElementById('heliaon-cod-form');
  var summary = modal.querySelector('[data-hlc-summary]');
  var totalsEl = modal.querySelector('[data-hlc-totals]');
  var submitBtn = modal.querySelector('[data-hlc-submit]');
  var submitLabelEl = modal.querySelector('[data-hlc-submit-label]');
  var successEl = modal.querySelector('[data-hlc-success]');
  var orderNameEl = modal.querySelector('[data-hlc-order-name]');
  var cartDot = document.getElementById('heliaon-cod-cart-dot');
  var pendingCountEl = document.querySelector('[data-hlc-pending-count]');
  var trustTopEl = modal.querySelector('[data-hlc-trust-top]');
  var upsellsEl = modal.querySelector('[data-hlc-upsells]');
  var upsellsRowEl = modal.querySelector('[data-hlc-upsells-row]');

  // ---- 7-day dedup guard (client-side, complements server) ----
  var HIST_KEY = 'heliaon_cod_history_v1';
  var HIST_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
  function readHistory() {
    try {
      var raw = localStorage.getItem(HIST_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) return [];
      var cutoff = Date.now() - HIST_WINDOW_MS;
      return arr.filter(function(x){ return x && x.at > cutoff; });
    } catch (e) { return []; }
  }
  function pushHistory(productId) {
    if (!productId) return;
    try {
      var arr = readHistory().filter(function(x){ return String(x.pid) !== String(productId); });
      arr.push({ pid: String(productId), at: Date.now() });
      localStorage.setItem(HIST_KEY, JSON.stringify(arr));
    } catch (e) {}
  }
  function orderedRecently(productId) {
    // HLN-COD-TEST-BYPASS v1 — ?hln_test=1 skips the 7-day dedup guard for manual testing.
    try {
      var _qs = new URLSearchParams(location.search);
      if (_qs.get('hln_test') === '1') return false;
    } catch(e){}
    return readHistory().some(function(x){ return String(x.pid) === String(productId); });
  }
  // Already-ordered popup show/hide
  var alreadyEl = document.getElementById('hln-cod-already');
  function alreadyShow() {
    if (!alreadyEl) return;
    alreadyEl.hidden = false;
    alreadyEl.setAttribute('aria-hidden','false');
    document.body.classList.add('hlc-modal-open');
  }
  function alreadyHide() {
    if (!alreadyEl) return;
    alreadyEl.hidden = true;
    alreadyEl.setAttribute('aria-hidden','true');
    document.body.classList.remove('hlc-modal-open');
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t) return;
    if (t.matches('[data-hlc-already-close]') || t.closest('[data-hlc-already-close]')) { alreadyHide(); }
  });

  var protectionEl = form ? form.querySelector('[data-hlc-field="protection"]') : null;
  var PENDING_KEY = 'heliaon_cod_pending_v1';
  var UPSELL_KEY = 'heliaon_cod_upsell_v1'; // per-open selected upsell variant ids
  var TOUCH_KEY = 'heliaon_cod_touched_v1';
  var NONCE = null;
  var DS = CFG.settings.downsell || { enable: false };
  var P = CFG.settings.pricing || { shipping_fee: 0, cod_fee: 0 };
  var PROT = CFG.settings.protection || { enabled: false, price: 0 };
  var LBL = CFG.settings.labels || {};
  var ERR = CFG.settings.errors || {};
  var UPSELLS = Array.isArray(CFG.upsells) ? CFG.upsells : [];
  var BULK = (CFG.settings && CFG.settings.bulk_discount) || { enabled: false, min_qty: 2, percent: 0 };
  var pendingDiscountCode = null;
  var downsellRoot = document.getElementById('hln-cod-downsell');
  var currentEvents = { initiate: null, addPayment: null, addPaymentFired: false };
  var lastFocused = null;
  var touched = {};
  // HLN-COD-MARKETS v1 — country dropdown (shown when MARKETS.length>1) + phone-cc reorder + dynamic fees.
  function applyMarket(iso) {
    var m = MARKETS.find(function(x){ return x.iso === iso; }) || MARKETS[0];
    currentMarket = m;
    C = COUNTRIES[m.iso] || C;
    // Update effective pricing (used by renderTotals / grandTotal / submit payload)
    P.shipping_fee = Number(m.shipping_fee) || 0;
    P.cod_fee      = Number(m.cod_fee)      || 0;
    // Update the phone-cc select to this market's prefix
    try {
      var ccSel = form.querySelector('[data-hlc-field="phone_country_code"]');
      if (ccSel && m.phone_cc) {
        var ok = Array.prototype.some.call(ccSel.options, function(o){ if (o.value === m.phone_cc) { o.selected = true; return true; } return false; });
        if (!ok) ccSel.value = m.phone_cc;
      }
    } catch(e){}
    try { renderTotals(); renderSummary(); } catch(e){}
  }
  function setupCountryUI() {
    // Reorder phone-cc <select>: put this market's countries first, dedup, keep others below.
    try {
      var ccSel = form.querySelector('[data-hlc-field="phone_country_code"]');
      if (ccSel) {
        var wanted = MARKETS.map(function(m){ return m.phone_cc; }).filter(Boolean);
        var byValue = {};
        Array.prototype.forEach.call(ccSel.options, function(o){ byValue[o.value] = o; });
        var seen = {};
        // Prepend market options
        for (var i = wanted.length - 1; i >= 0; i--) {
          var v = wanted[i];
          if (!byValue[v] || seen[v]) continue;
          seen[v] = 1;
          ccSel.insertBefore(byValue[v], ccSel.firstChild);
        }
      }
    } catch(e){}
    // Country dropdown: reveal only if >1 country
    try {
      var wrap = form.querySelector('[data-hlc-field-wrap="country"]');
      var sel  = form.querySelector('[data-hlc-field="country"]');
      if (wrap && sel) {
        sel.innerHTML = '';
        MARKETS.forEach(function(m){
          var o = document.createElement('option');
          o.value = m.iso;
          o.textContent = m.label || m.iso;
          sel.appendChild(o);
        });
        sel.value = currentMarket.iso;
        wrap.hidden = MARKETS.length <= 1;
        sel.addEventListener('change', function(){ applyMarket(sel.value); });
      }
    } catch(e){}
    applyMarket(currentMarket.iso);
  }
  setupCountryUI();
  var addressHasValue = false;
  function anyAddressFilled(){
    var a = form.querySelector('[data-hlc-field="address1"]');
    var c = form.querySelector('[data-hlc-field="city"]');
    var z = form.querySelector('[data-hlc-field="zip"]');
    return (a && a.value.trim()) || (c && c.value.trim()) || (z && z.value.trim());
  }
  var selectedUpsells = readUpsells(); // {variant_id: qty}
  var CUR = CFG.product.currency_local || CFG.product.currency || 'PLN';
  var LOCALE = CFG.locale || 'pl-PL';
  var CUR_SUFFIX = (CUR === 'PLN') ? ' zł' : (' ' + CUR);
  var fmtNum;
  try {
    fmtNum = new Intl.NumberFormat(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch (e) {
    fmtNum = { format: function (n) { return (Number(n) || 0).toFixed(2).replace('.', ','); } };
  }
  var fmtCurrency = { format: function (n) { return fmtNum.format(Number(n) || 0) + CUR_SUFFIX; } };

  // Country-code -> regex for phone digit count
  var COUNTRY_DIGIT_RULES = { '+48':{min:9,max:9}, '+40':{min:9,max:9}, '+420':{min:9,max:9}, '+36':{min:8,max:9}, '+30':{min:10,max:10}, '+49':{min:10,max:12}, '+43':{min:10,max:11}, '+41':{min:9,max:9}, '+421':{min:9,max:9}, '+380':{min:9,max:9}, '+375':{min:9,max:9}, '+370':{min:8,max:8}, '+371':{min:8,max:8}, '+372':{min:7,max:8}, '+373':{min:8,max:8}, '+385':{min:8,max:9}, '+386':{min:8,max:9}, '+381':{min:8,max:9}, '+387':{min:8,max:8}, '+382':{min:8,max:8}, '+389':{min:8,max:8}, '+355':{min:9,max:9}, '+359':{min:8,max:9}, '+357':{min:8,max:8}, '+356':{min:8,max:8}, '+352':{min:9,max:9}, '+31':{min:9,max:9}, '+32':{min:8,max:9}, '+33':{min:9,max:9}, '+39':{min:9,max:10}, '+34':{min:9,max:9}, '+351':{min:9,max:9}, '+353':{min:9,max:9}, '+44':{min:10,max:10}, '+45':{min:8,max:8}, '+46':{min:9,max:9}, '+47':{min:8,max:8}, '+358':{min:9,max:10}, '+354':{min:7,max:7} };
  function phoneRuleFor(cc) { return COUNTRY_DIGIT_RULES[cc] || { min: 7, max: 12 }; }

  // --- pending buy list --------------------------------------------------
  function readPending() {
    try { return JSON.parse(localStorage.getItem(PENDING_KEY) || '[]'); } catch (e) { return []; }
  }
  function writePending(list) {
    try { localStorage.setItem(PENDING_KEY, JSON.stringify(list)); } catch (e) {}
    updateCartDot();
    updatePendingPill();
  }
  function addPending(item) {
    var list = readPending();
    var idx = list.findIndex(function (x) { return x.variant_id === item.variant_id; });
    if (idx >= 0) list[idx].quantity += item.quantity;
    else list.push(item);
    writePending(list);
  }
  function readUpsells() {
    try { return JSON.parse(sessionStorage.getItem(UPSELL_KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeUpsells() {
    try { sessionStorage.setItem(UPSELL_KEY, JSON.stringify(selectedUpsells)); } catch (e) {}
  }
  function updateCartDot() {
    if (!cartDot) return;
    var list = readPending();
    var count = list.reduce(function (s, it) { return s + it.quantity; }, 0);
    // Cart button always visible; only badge toggles based on count
    if (pendingCountEl) pendingCountEl.textContent = String(count || 0);
    if (count > 0) cartDot.classList.add('has-items');
    else cartDot.classList.remove('has-items');
  }
  function updatePendingPill(){ var e=document.querySelector('.hlc-pending-pill,[data-hlc-pending-pill]'); if(e) e.remove(); }

  // --- open/close --------------------------------------------------------
  function open() {
    // HLN-COD-DEDUP-DISABLED v1 — 7-day dedup guard is OFF while we're still testing.
    // Re-enable by removing this comment block and restoring the orderedRecently check.
    // if (orderedRecently(CFG.product.id)) { alreadyShow(); return; }
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hlc-modal-open');
    try { if (!window.__hlcHistPushed) { history.pushState({ hlcCod: 1 }, ''); window.__hlcHistPushed = true; } } catch (e) {}
    lastFocused = document.activeElement;
    touched = {};
    addressHasValue = false;
    Array.prototype.forEach.call(form.querySelectorAll('.hlc-field.is-invalid'), function (w) { w.classList.remove('is-invalid'); });
    renderTrustTop();
    renderSummary();
    renderUpsells();
    renderTotals();
    successEl.hidden = true;
    form.hidden = false;
    NONCE = null;
    fetchNonce().catch(function (e) { console.warn('[hlc] nonce', e); });
    currentEvents.initiate = crypto.randomUUID();
    currentEvents.addPayment = null;
    currentEvents.addPaymentFired = false;
    firePixel('InitiateCheckout', currentEvents.initiate);
    trackServer('InitiateCheckout', currentEvents.initiate);
    setTimeout(function () {
      var first = form.querySelector('input:not([type=checkbox]):not([type=hidden])');
      if (first) first.focus();
    }, 60);
    if (CFG.settings.countdown_enabled) startCountdown();
    renderAppliedPill();
  }
  function shouldShowDownsell() {
    // Iteration 4: UNLIMITED, fire on EVERY close attempt (no session guard)
    return !!(DS && DS.enable && downsellRoot && !pendingDiscountCode);
  }
  function openDownsell() {
    if (!downsellRoot) return;
    downsellRoot.hidden = false;
    downsellRoot.setAttribute('aria-hidden', 'false');
    var id = crypto.randomUUID();
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'FormAbandonedShownDownsell', {}, { eventID: id }); } catch (e) {}
    trackServer('FormAbandonedShownDownsell', id, { value: 0 });
  }
  function closeDownsell() {
    if (!downsellRoot) return;
    downsellRoot.hidden = true;
    downsellRoot.setAttribute('aria-hidden', 'true');
  }
  function jiggleDownsell() {
    if (!downsellRoot) return;
    var panel = downsellRoot.querySelector('.hlc-ds-panel');
    if (panel) { panel.classList.remove('hlc-jiggle'); void panel.offsetWidth; panel.classList.add('hlc-jiggle'); }
  }
  function renderAppliedPill() { var e=document.querySelector(".hlc-applied-pill,.hlc-ds-applied"); if (e) e.remove(); return; }
  function close(opts) {
    opts = opts || {};
    if (root.hidden) return;
    if (!opts.force && shouldShowDownsell()) {
      openDownsell();
      return;
    }
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hlc-modal-open');
    window.__hlcHistPushed = false;
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    if (CFG.settings.abandonment_recovery && hasTouched()) {
      var id = crypto.randomUUID();
      trackServer('FormAbandoned', id, { value: 0 });
    }
    // Do NOT auto-add on close — that caused counts to drift/double.
    // Pending list is only populated by explicit user action (adding upsells during form fill = tracked in selectedUpsells only).
    // The header cart bubble reflects TRUE pending items from localStorage which are only added by dedicated flows.
  }
  function acceptDownsell() {
    pendingDiscountCode = (DS && DS.discount_code) || null;
    var id = crypto.randomUUID();
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'AcceptedDownsell', { code: pendingDiscountCode }, { eventID: id }); } catch (e) {}
    trackServer('AcceptedDownsell', id, { value: 0 });
    closeDownsell();
    if (root.hidden) open();
    renderAppliedPill();
    try { renderTotals(); renderSummary(); } catch(e){}
  }
  function openWithDiscount() {
    pendingDiscountCode = (DS && DS.discount_code) || 'HELIAON10';
    if (root.hidden) open();
    try { renderAppliedPill(); renderTotals(); renderSummary(); } catch (e) {}
  }
  function refuseDownsell() {
    var id = crypto.randomUUID();
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'RefusedDownsell', {}, { eventID: id }); } catch (e) {}
    trackServer('RefusedDownsell', id, { value: 0 });
    closeDownsell();
    close({ force: true });
  }
  function hasTouched() {
    try { return sessionStorage.getItem(TOUCH_KEY) === '1'; } catch (e) { return false; }
  }
  function markTouched() { try { sessionStorage.setItem(TOUCH_KEY, '1'); } catch (e) {} }

  // --- trust top ---------------------------------------------------------
  function renderTrustTop() {
    if (!trustTopEl) return;
    var tt = (CFG.settings && CFG.settings.trust_top) || {};
    if (!tt.enabled) { trustTopEl.hidden = true; return; }
    trustTopEl.hidden = false;
    var photosEl = trustTopEl.querySelector('[data-hlc-trust-top-photos]');
    var starsEl = trustTopEl.querySelector('[data-hlc-trust-top-stars]');
    var photos = (tt.photos || []).filter(Boolean);
    if (photosEl) {
      photosEl.innerHTML = '';
      photosEl.hidden = false;
      var PLACEHOLDER_SVG = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="24" cy="18" r="8" fill="currentColor"/><path d="M8 44c0-8 7-14 16-14s16 6 16 14" fill="currentColor"/></svg>';
      var sprIdx = tt.sprite_idx || [];
      var sprN = Math.max(1, Number(tt.sprite_count) || 6);
      for (var i = 0; i < 3; i++) {
        var slot = document.createElement('div');
        slot.className = 'hlc-avatar';
        slot.style.zIndex = String(10 - i);
        if (tt.sprite && sprIdx[i] != null && sprIdx[i] >= 0) {
          // HLN-COD-SPRITE: draw a slice of the montage — no <img>, no clean file over the network
          var k = sprIdx[i];
          slot.style.backgroundImage = "url('" + tt.sprite + "')";
          slot.style.backgroundSize = "100% " + (sprN * 100) + "%";
          slot.style.backgroundPosition = "0 " + (sprN > 1 ? (k / (sprN - 1) * 100) : 0) + "%";
          slot.style.backgroundRepeat = "no-repeat";
          slot.style.webkitUserSelect = "none";
          slot.style.userSelect = "none";
          slot.style.webkitUserDrag = "none";
          slot.style.webkitTouchCallout = "none";
        } else if (photos[i]) {
          var img = document.createElement('img');
          img.src = photos[i];
          img.alt = '';
          slot.appendChild(img);
        } else {
          slot.classList.add('hlc-avatar--placeholder');
          slot.innerHTML = PLACEHOLDER_SVG;
        }
        photosEl.appendChild(slot);
      }
    }
    if (starsEl) {
      var n = Math.max(1, Math.min(5, Number(tt.stars) || 5));
      starsEl.textContent = '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
    }
  }

  // --- upsell row --------------------------------------------------------
  function renderUpsells() {
    if (!upsellsEl || !upsellsRowEl) return;
    if (!UPSELLS.length) { upsellsEl.hidden = true; return; }
    upsellsEl.hidden = false;
    upsellsRowEl.innerHTML = '';
    UPSELLS.forEach(function (u) {
      var card = document.createElement('div');
      card.className = 'hlc-upsell-card';
      card.setAttribute('data-hlc-upsell', String(u.variant_id));
      var img = document.createElement('img');
      img.className = 'hlc-upsell-thumb';
      img.src = u.image || '';
      img.alt = u.title || '';
      var body = document.createElement('div');
      body.className = 'hlc-upsell-body';
      var title = document.createElement('a');
      title.className = 'hlc-upsell-title';
      title.textContent = u.title || '';
      title.href = u.url || '#';
      title.addEventListener('click', function (e) {
        e.preventDefault();
        // Save current selection to localStorage so we can restore on the target PDP
        try { sessionStorage.setItem('hln_cod_last_selected', JSON.stringify({ back_to: location.href, at: Date.now() })); } catch (e2) {}
        location.href = title.href;
      });
      var price = document.createElement('div');
      price.className = 'hlc-upsell-price';
      price.textContent = fmtCurrency.format(Number(u.price) || 0);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hlc-upsell-add';
      btn.setAttribute('aria-label', 'Dodaj do zamówienia');
      btn.textContent = u.add_button_text || '+';
      var isSelected = !!selectedUpsells[u.variant_id];
      if (isSelected) { card.classList.add('is-selected'); btn.textContent = '✓'; }
      btn.addEventListener('click', function () {
        if (selectedUpsells[u.variant_id]) {
          delete selectedUpsells[u.variant_id];
          card.classList.remove('is-selected');
          btn.textContent = u.add_button_text || '+';
        } else {
          selectedUpsells[u.variant_id] = { variant_id: u.variant_id, quantity: 1, unit_price: Number(u.price) || 0, title: u.title };
          card.classList.add('is-selected');
          btn.textContent = '✓';
        }
        writeUpsells();
        renderSummary();
        renderTotals();
      });
      body.appendChild(title);
      body.appendChild(price);
      card.appendChild(img);
      card.appendChild(body);
      card.appendChild(btn);
      upsellsRowEl.appendChild(card);
    });
  }

  // --- summary + qty -----------------------------------------------------
  function renderSummary() {
    var v = currentVariant();
    var qty = getQty();
    summary.innerHTML = '';
    var main = document.createElement('div');
    main.className = 'hlc-sum-line';
    var img = document.createElement('img');
    img.src = CFG.product.image || '';
    img.alt = CFG.product.title || '';
    var body = document.createElement('div');
    body.className = 'hlc-sum-body';
    var title = document.createElement('div');
    title.className = 'hlc-sum-title';
    title.textContent = CFG.product.title;
    var qWrap = document.createElement('div');
    qWrap.className = 'hlc-qty';
    var minus = mkBtn('-'); var input = mkInput(qty); var plus = mkBtn('+');
    minus.addEventListener('click', function () { setQty(Math.max(1, qty - 1)); renderSummary(); renderTotals(); });
    plus.addEventListener('click', function () { setQty(qty + 1); renderSummary(); renderTotals(); });
    input.addEventListener('change', function () { setQty(Math.max(1, parseInt(input.value, 10) || 1)); renderSummary(); renderTotals(); });
    qWrap.appendChild(minus); qWrap.appendChild(input); qWrap.appendChild(plus);
    body.appendChild(title); body.appendChild(qWrap);
    main.appendChild(img); main.appendChild(body);
    summary.appendChild(main);
    // Bulk discount hint now lives in the upsells heading (see liquid). Nothing appended here.
    // Selected upsells are managed via the upsell + button (toggle). No summary line, no trash.
  }
  function renderTotals() {
    if (!totalsEl) return;
    var v = currentVariant();
    var qty = getQty();
    var product = (Number(v.price) || 0) * qty;
    var upsellTotal = Object.keys(selectedUpsells).reduce(function (s, k) { return s + (Number(selectedUpsells[k].unit_price) || 0); }, 0);
    var cityEl = form.querySelector('[data-hlc-field="city"]');
    var cityFilled = !!(cityEl && cityEl.value.trim());
    var shipping = cityFilled ? (Number(P.shipping_fee) || 0) : 0;
    var codFee = Number(P.cod_fee) || 0;  // always applied from open
    var protectionOn = !!(protectionEl && protectionEl.checked);
    var protectionAmt = (PROT.enabled && protectionOn) ? (Number(PROT.price) || 0) : 0;
    var bulkDisc = 0;
    var totalItemsT = qty + Object.keys(selectedUpsells).length;
    if (BULK && BULK.enabled && totalItemsT >= (Number(BULK.min_qty) || 2)) {
      bulkDisc = (product + upsellTotal) * ((Number(BULK.percent) || 0) / 100);
    }
    var grand = product + upsellTotal + shipping + codFee + protectionAmt - bulkDisc - (pendingDiscountCode ? product * (((DS&&DS.percent)||10)/100) : 0);
    var rows = '';
    rows += row(LBL.subtotal || 'Produkt', product);
    if (upsellTotal > 0) rows += row('Dodatki', upsellTotal);
    if (cityFilled && (Number(P.shipping_fee) || 0) > 0) rows += row(LBL.shipping || 'Dostawa', shipping);
    if (codFee > 0) rows += row(LBL.cod_fee || 'Płatność przy odbiorze', codFee);
    if (protectionAmt > 0) rows += row(LBL.protection || 'Protection', protectionAmt);
    
    // Downsell discount line (auto-applied by Shopify from HELIAON10 code)
    var dsPct = (DS && DS.percent) || 10;
    var dsCode = (DS && DS.discount_code) || '';
    var dsDisc = 0;
    if (pendingDiscountCode) {
      dsDisc = product * (dsPct / 100);
      var _rabatMap = { pl:'Rabat', ro:'Reducere', cz:'Sleva', hu:'Kedvezmény', el:'Έκπτωση' };
      var _rabatWord = _rabatMap[CFG.language] || 'Rabat';
      rows += '<div class="hlc-totals-row hlc-totals-disc"><span>' + esc(_rabatWord + ' -' + dsPct + '% (' + dsCode + ')') + '</span><span class="hlc-totals-value">-' + esc(fmtCurrency.format(dsDisc)) + '</span></div>';
    }
    if (bulkDisc > 0) rows += '<div class="hlc-totals-row hlc-totals-disc"><span>' + esc((BULK.line_label || 'Rabat') + ' ' + (BULK.percent || 15) + '%') + '</span><span class="hlc-totals-value">-' + esc(fmtCurrency.format(bulkDisc)) + '</span></div>';
    rows += '<div class="hlc-totals-row hlc-totals-grand"><span>' + esc(LBL.total || 'Cena łącznie') + '</span><span class="hlc-totals-value">' + esc(fmtCurrency.format(grand)) + '</span></div>';
    totalsEl.innerHTML = rows;
    function row(label, val) {
      return '<div class="hlc-totals-row"><span>' + esc(label) + '</span><span class="hlc-totals-value">' + esc(fmtCurrency.format(val)) + '</span></div>';
    }
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[m]; }); }
  function mkBtn(t) { var b = document.createElement('button'); b.type = 'button'; b.textContent = t; return b; }
  function mkInput(v) { var i = document.createElement('input'); i.type = 'text'; i.inputMode = 'numeric'; i.value = String(v); return i; }
  var _qty = 1;
  function getQty() { return _qty; }
  function setQty(n) { _qty = Math.max(1, Math.min(5, n)); }
  function currentVariant() {
    return CFG.product.variants.find(function (v) { return v.id === CFG.product.default_variant_id; }) || CFG.product.variants[0];
  }
  function grandTotal() {
    var v = currentVariant();
    var qty = getQty();
    var product = (Number(v.price) || 0) * qty;
    var upsellTotal = Object.keys(selectedUpsells).reduce(function (s, k) { return s + (Number(selectedUpsells[k].unit_price) || 0); }, 0);
    var shipping = Number(P.shipping_fee) || 0;
    var codFee = Number(P.cod_fee) || 0;
    var protectionOn = !!(protectionEl && protectionEl.checked);
    var protectionAmt = (PROT.enabled && protectionOn) ? (Number(PROT.price) || 0) : 0;
    var bulkDisc = 0;
    var totalItemsG = qty + Object.keys(selectedUpsells).length;
    if (BULK && BULK.enabled && totalItemsG >= (Number(BULK.min_qty) || 2)) {
      bulkDisc = (product + upsellTotal) * ((Number(BULK.percent) || 0) / 100);
    }
    return product + upsellTotal + shipping + codFee + protectionAmt - bulkDisc - (pendingDiscountCode ? product * (((DS&&DS.percent)||10)/100) : 0);
  }

  // --- countdown ---------------------------------------------------------
  var timerHandle = null;
  function startCountdown() {
    if (timerHandle) return;
    var target = Date.now() + (CFG.settings.countdown_hours * 3600 + CFG.settings.countdown_minutes * 60) * 1000;
    var el = modal.querySelector('[data-hlc-time]');
    if (!el) return;
    tick();
    timerHandle = setInterval(tick, 1000);
    function tick() {
      var left = Math.max(0, target - Date.now());
      var s = Math.floor(left / 1000) % 60;
      var m = Math.floor(left / 60000) % 60;
      var h = Math.floor(left / 3600000);
      el.textContent = (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
      if (left === 0) { clearInterval(timerHandle); timerHandle = null; }
    }
  }

  // --- validation --------------------------------------------------------
  function currentCountryCode() {
    var sel = form.querySelector('[data-hlc-field="phone_country_code"]');
    return sel ? sel.value : '+48';
  }
  function validateField(name, value) {
    value = (value || '').trim();
    switch (name) {
      case 'first_name': return value.length >= 2 ? '' : (ERR.first_name || 'Enter first name');
      case 'last_name':  return value.length >= 2 ? '' : (ERR.last_name  || 'Enter last name');
      case 'email':
        if (!value) return ''; // optional
        var reE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return reE.test(value) ? '' : (ERR.email || 'Enter a valid e-mail address');
      case 'phone': {
        // HLN-COD-PHONE-LENIENT v1 — length-only, strips duplicated country prefix + leading zero.
        var digits = value.replace(/\D/g, '');
        var cc = currentCountryCode();
        var ccDigits = cc.replace(/\D/g, '');
        // If user typed the country prefix inside the phone field (e.g. "+30 691…" or "0030 691…"), strip it.
        if (digits.length > 8 && ccDigits && digits.indexOf(ccDigits) === 0) digits = digits.slice(ccDigits.length);
        // Also strip a single leading 0 (some people type national trunk prefix).
        if (digits.length > 8 && digits.charAt(0) === '0') digits = digits.slice(1);
        var rule = phoneRuleFor(cc);
        // HLN-COD-PHONE-STRICT v2 — must match the exact national length for the chosen country code (catch a missing digit).
        var minL = rule.min;
        var maxL = rule.max;
        if (digits.length >= minL && digits.length <= maxL) return '';
        if (!digits.length) return (ERR.phone || 'Enter phone');
        if (digits.length < minL) {
          var missing = minL - digits.length;
          var t = ERR.phone_short || (ERR.phone || 'Phone too short ({n} missing)');
          return t.replace('{n}', missing);
        }
        var extra = digits.length - maxL;
        var t2 = ERR.phone_long || (ERR.phone || 'Phone too long ({n} extra)');
        return t2.replace('{n}', extra);
      }
      case 'phone_confirm':
        return value === 'on' ? '' : (ERR.phone_confirm || 'Confirm your phone number');
      case 'address1': {
        if (value.length < 3) return (ERR.address || 'Enter address');
        if (!/\d/.test(value)) return (ERR.address_no_number || ERR.address || 'Add house number');
        return '';
      }
      case 'zip':
        // Loose: any 3+ chars, digits/letters/spaces/dashes accepted. No format enforcement.
        return value.replace(/[\s-]/g,'').length >= 3 ? '' : (ERR.postal || 'Enter postal code');
      case 'city': return value.length >= 2 ? '' : (ERR.city || 'Enter city');
      default: return '';
    }
  }
  function fieldWrap(name) {
    var el = form.querySelector('[data-hlc-field="' + name + '"]');
    return el && el.closest('.hlc-field');
  }
  function setError(name, msg) {
    var wrap = fieldWrap(name);
    if (!wrap) return;
    var err = wrap.querySelector('[data-hlc-err="' + name + '"]');
    if (msg) { wrap.classList.add('is-invalid'); if (err) err.textContent = msg; }
    else { wrap.classList.remove('is-invalid'); if (err) err.textContent = ''; }
  }
  function requiredFields() { return ['first_name', 'last_name', 'phone', 'phone_confirm', 'address1', 'city', 'zip']; }

  form.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.name) return;
    markTouched();
    var name = el.name;
    if (name === 'protection') { renderTotals(); return; }
    if (name === 'city' || name === 'address1' || name === 'zip') {
      addressHasValue = anyAddressFilled();
      renderTotals();
    }
    if (name === 'phone_country_code') {
      // Re-validate phone on cc change
      var phoneEl = form.querySelector('[data-hlc-field="phone"]');
      if (phoneEl && touched.phone) {
        var e2 = validateField('phone', phoneEl.value);
        setError('phone', e2);
      }
      return;
    }
    if (touched[name]) {
      var val = el.type === 'checkbox' ? (el.checked ? 'on' : '') : el.value;
      var err = validateField(name, val);
      if (!err) setError(name, '');
    }
    maybeFirePaymentInfo();
    fireAdvancedMatching();
  });
  form.addEventListener('blur', function (e) {
    var el = e.target;
    if (!el || !el.name) return;
    var name = el.name;
    if (name === 'protection' || name === 'phone_country_code') return;
    touched[name] = true;
    if (name === 'city' || name === 'address1' || name === 'zip') {
      addressHasValue = anyAddressFilled();
      renderTotals();
    }
    var val = el.type === 'checkbox' ? (el.checked ? 'on' : '') : el.value;
    var err = validateField(name, val);
    setError(name, err);
    maybeFirePaymentInfo();
    fireAdvancedMatching();
  }, true);

  // HLN-COD-META-ADV-MATCH v1 — SHA-256 hash contact fields and re-init the Meta pixel with Advanced Matching.
  // Runs whenever the user types email / phone / name / city / zip. Lifts EMQ score → cheaper CPA.
  var _amInited = false;
  function _amHash(s) {
    try {
      var enc = new TextEncoder().encode(String(s || '').trim().toLowerCase());
      return crypto.subtle.digest('SHA-256', enc).then(function(buf){
        var h = Array.prototype.map.call(new Uint8Array(buf), function(b){ return ('00'+b.toString(16)).slice(-2); }).join('');
        return h;
      });
    } catch(e){ return Promise.resolve(''); }
  }
  function fireAdvancedMatching() {
    try {
      if (typeof window.fbq !== 'function') return;
      var pid = CFG.pixel_id; if (!pid) return;
      var fn = (form.first_name && form.first_name.value || '').trim();
      var ln = (form.last_name  && form.last_name.value  || '').trim();
      var em = (form.email      && form.email.value      || '').trim();
      var phDigits = String(form.phone && form.phone.value || '').replace(/\D/g,'');
      var ct = (form.city  && form.city.value || '').trim();
      var zp = (form.zip   && form.zip.value  || '').trim().replace(/\s+/g,'');
      // Need at least one of (email, phone) to bother
      if (!em && !phDigits) return;
      Promise.all([
        em ? _amHash(em) : Promise.resolve(''),
        phDigits ? _amHash(phDigits) : Promise.resolve(''),
        fn ? _amHash(fn) : Promise.resolve(''),
        ln ? _amHash(ln) : Promise.resolve(''),
        ct ? _amHash(ct) : Promise.resolve(''),
        zp ? _amHash(zp) : Promise.resolve('')
      ]).then(function(hs){
        var match = {};
        if (hs[0]) match.em = hs[0];
        if (hs[1]) match.ph = hs[1];
        if (hs[2]) match.fn = hs[2];
        if (hs[3]) match.ln = hs[3];
        if (hs[4]) match.ct = hs[4];
        if (hs[5]) match.zp = hs[5];
        if (Object.keys(match).length === 0) return;
        try { window.fbq('init', String(pid), match); _amInited = true; } catch(e){}
      }).catch(function(){});
    } catch(e){}
  }
  function maybeFirePaymentInfo() {
    if (currentEvents.addPaymentFired) return;
    // Fires EARLY: as soon as first_name + last_name + phone are valid.
    // Rationale: with name+phone we can already contact the lead (COD), so treat that as payment-info-added for optimization.
    var fn = form.querySelector('[data-hlc-field="first_name"]');
    var ln = form.querySelector('[data-hlc-field="last_name"]');
    var ph = form.querySelector('[data-hlc-field="phone"]');
    if (!fn || !ln || !ph) return;
    if (validateField('first_name', fn.value)) return;
    if (validateField('last_name',  ln.value)) return;
    if (validateField('phone',      ph.value)) return;
    currentEvents.addPaymentFired = true;
    currentEvents.addPayment = crypto.randomUUID();
    firePixel('AddPaymentInfo', currentEvents.addPayment);
    trackServer('AddPaymentInfo', currentEvents.addPayment);
  }

  function allValid(silent) {
    var reqs = requiredFields();
    var ok = true;
    reqs.forEach(function (name) {
      var el = form.querySelector('[data-hlc-field="' + name + '"]');
      if (!el) return;
      var val = el.type === 'checkbox' ? (el.checked ? 'on' : '') : el.value;
      var err = validateField(name, val);
      if (!silent) setError(name, err);
      if (err) ok = false;
    });
    // email optional but if present must be valid
    var emailEl = form.querySelector('[data-hlc-field="email"]');
    if (emailEl && emailEl.value.trim()) {
      var eErr = validateField('email', emailEl.value);
      if (!silent) setError('email', eErr);
      if (eErr) ok = false;
    }
    return ok;
  }

  // --- pixel / capi ------------------------------------------------------
  // Fires BOTH Meta (fbq) and TikTok (ttq) client-side with matching eventId
  // for future CAPI-side deduplication.
  var TT_EVENT_MAP = { 'Purchase':'CompletePayment', 'InitiateCheckout':'InitiateCheckout', 'AddPaymentInfo':'AddPaymentInfo', 'ViewContent':'ViewContent', 'AddToCart':'AddToCart' };
  function firePixel(name, eventId, extra) {
    var v = currentVariant();
    var qty = getQty();
    var total = grandTotal();
    var params = Object.assign({
      value: total, currency: CFG.product.currency,
      content_ids: [String(v.id)], content_type: 'product', num_items: qty,
    }, extra || {});
    try { if (typeof window.fbq === 'function') window.fbq('track', name, params, { eventID: eventId }); } catch (e) {}
    try {
      if (window.ttq && typeof window.ttq.track === 'function') {
        var ttName = TT_EVENT_MAP[name] || name;
        window.ttq.track(ttName, {
          value: total, currency: CFG.product.currency,
          content_id: String(v.id), content_type: 'product', quantity: qty
        }, { event_id: eventId });
      }
    } catch (e) {}
  }
  function trackServer(name, eventId, extra) {
    var v = currentVariant();
    var qty = getQty();
    var body = Object.assign({
      event: name, event_id: eventId, language: CFG.language,
      value: grandTotal(), currency: CFG.product.currency,
      content_ids: [String(v.id)], num_items: qty,
      product_id: CFG.product.id,
      pixel_id: CFG.pixel_id || null,
      tiktok_pixel_id: CFG.tiktok_pixel_id || null,
      fbc: getCookie('_fbc'), fbp: getCookie('_fbp'),
      ttp: getCookie('_ttp'), ttclid: getCookie('ttclid') || (function(){ try { return (new URLSearchParams(location.search)).get('ttclid') || ''; } catch(e){ return ''; } })(),
      event_source_url: location.href,
    }, extra || {});
    var url = CFG.endpoint + '/track?shop=' + encodeURIComponent(CFG.shop_domain);
    try { navigator.sendBeacon ? navigator.sendBeacon(url, JSON.stringify(body)) :
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true }); }
    catch (e) {}
  }
  function getCookie(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }

  // HLN-COD-ATTRIB v1 — front-end attribution capture (Meta IDs + UTMs + click IDs).
  // Captures on load, persists first-touch (write-once) + last-paid-touch, synthesizes _fbc from fbclid.
  // NOTE: capture only. Server-side pixel/CAPI passing is wired separately (end-stage).
  function _setCookie(k, val, days) { try { var d = new Date(); d.setTime(d.getTime() + (days || 90) * 864e5); document.cookie = k + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax'; } catch (e) {} }
  var HLN_ATTR_KEYS = ['utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term','campaign_id','adset_id','ad_id','account_key','fbclid'];
  function _captureTouch() {
    var t = {};
    try { var qs = new URLSearchParams(location.search); HLN_ATTR_KEYS.forEach(function(k){ var v = qs.get(k); if (v) t[k] = v; }); } catch (e) {}
    t.landing_page = location.href; t.referrer = document.referrer || ''; t.ts = Date.now();
    return t;
  }
  function _isPaidTouch(t) { return !!(t.utm_source || t.fbclid || t.campaign_id || t.ad_id || t.utm_campaign); }
  var HLN_ATTR = null;
  function initAttribution() {
    var cur = _captureTouch();
    if (cur.fbclid && !getCookie('_fbc')) { _setCookie('_fbc', 'fb.1.' + Date.now() + '.' + cur.fbclid, 90); }
    var store = {};
    try { store = JSON.parse(localStorage.getItem('hln_attr') || '{}'); } catch (e) {}
    if (!store.first_touch) { store.first_touch = cur; }
    if (_isPaidTouch(cur)) { store.last_paid_touch = cur; }
    if (!store.last_paid_touch) { store.last_paid_touch = store.first_touch; }
    try { localStorage.setItem('hln_attr', JSON.stringify(store)); } catch (e) {}
    HLN_ATTR = store; return store;
  }
  function getAttribution() {
    var s = HLN_ATTR || initAttribution();
    return { first_touch: s.first_touch || null, last_paid_touch: s.last_paid_touch || null, fbc: getCookie('_fbc') || null, fbp: getCookie('_fbp') || null };
  }
  try { initAttribution(); } catch (e) {}

  function fetchNonce() {
    return fetch(CFG.endpoint + '/nonce?shop=' + encodeURIComponent(CFG.shop_domain) + '&language=' + CFG.language, { credentials: 'include' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.ok) NONCE = j.nonce; });
  }

  // --- submit ------------------------------------------------------------
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    requiredFields().forEach(function (n) { touched[n] = true; });
    if (!allValid(false)) {
      var firstErr = form.querySelector('.is-invalid');
      if (firstErr) firstErr.scrollIntoView({ block: 'center', behavior: 'smooth' });
      // HLN-COD-VALIDATION-TOAST v1 — ephemeral pop-up so the customer notices something is missing.
      var _tmap = {
        el: 'Παρακαλώ συμπληρώστε τα κόκκινα πεδία.',
        pl: 'Uzupełnij zaznaczone pola.',
        ro: 'Vă rugăm completați câmpurile marcate.',
        cz: 'Doplňte označená pole.',
        hu: 'Kérjük, töltse ki a jelölt mezőket.'
      };
      showValidationToast(_tmap[CFG.language] || _tmap.el);
      return;
    }
    submitBtn.disabled = true;
    submitLabelEl.textContent = CFG.settings.submit_loading;

    var v = currentVariant();
    var qty = getQty();

    // HLN-COD-NO-PENDING-IN-ORDER v1 — never mix stale localStorage pending items into the payload.
    // The modal only shows the current product + selectedUpsells; sending anything else would create
    // ghost line items the customer never confirmed (once caused a €15k phantom order in testing).
    var upsellItems = Object.keys(selectedUpsells).map(function (k) {
      var it = selectedUpsells[k];
      return { variant_id: it.variant_id, quantity: it.quantity || 1, unit_price: Number(it.unit_price) || 0 };
    });
    var lineItems = [{ variant_id: v.id, quantity: qty, unit_price: Number(v.price) }].concat(upsellItems);

    var cc = currentCountryCode();
    // HLN-COD-PHONE-LENIENT v1 — mirror validator's cleanup so the payload phone is normalized.
    var phoneDigits = String(form.phone.value || '').replace(/\D/g, '');
    var _ccDigits = cc.replace(/\D/g, '');
    if (phoneDigits.length > 8 && _ccDigits && phoneDigits.indexOf(_ccDigits) === 0) phoneDigits = phoneDigits.slice(_ccDigits.length);
    if (phoneDigits.length > 8 && phoneDigits.charAt(0) === '0') phoneDigits = phoneDigits.slice(1);
    var protectionOn = !!(protectionEl && protectionEl.checked);

    // HLN-COD-UTM v1 — pull UTMs + cart token + referrer so the order note mirrors EasySell.
    var _utm = {};
    try {
      var _qs = new URLSearchParams(location.search);
      ['utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term','campaign_id','adset_id','ad_id','account_key','fbclid'].forEach(function(k){
        var v = _qs.get(k); if (v) _utm[k] = v;
      });
    } catch(e){}
    var _cartToken = getCookie('cart') || '';

    var payload = {
      nonce: NONCE,
      shop_domain: CFG.shop_domain,
      product_id: CFG.product.id,
      language: CFG.language,
      currency: CFG.product.currency,
      pixel_id: CFG.pixel_id || null,
      utm: _utm,
      attribution: (function(){ try { return getAttribution(); } catch(e){ return null; } })(),
      shopify_cart_token: _cartToken,
      customer: {
        first_name: form.first_name.value.trim(),
        last_name: form.last_name.value.trim(),
        full_name: (form.first_name.value.trim() + ' ' + form.last_name.value.trim()).trim(),
        phone_country_code: cc,
        phone_number: phoneDigits,
        phone: cc + phoneDigits,
        email: form.email.value.trim(),
      },
      address: {
        address1: form.address1.value.trim(),
        address2: null,
        city: form.city.value.trim(),
        zip: form.zip.value.trim(),
        country_code: C.iso,
      },
      note: form.note.value.trim(),
      line_items: lineItems,
      upsell_variant_ids: upsellItems.map(function (x) { return x.variant_id; }),
      protection: protectionOn,
      shipping_fee: Number(P.shipping_fee) || 0,
      cod_fee: Number(P.cod_fee) || 0,
      bulk_discount: (BULK && BULK.enabled && (qty + Object.keys(selectedUpsells).length) >= (Number(BULK.min_qty) || 2)) ? { min_qty: Number(BULK.min_qty) || 2, percent: Number(BULK.percent) || 0 } : null,
      discount_code: pendingDiscountCode || null,
      /* HLN-DISCOUNT-FIX: send the real % and euro amount so the order actually gets the discount (was 0.00) */
      discount_percent: pendingDiscountCode ? (((DS && DS.percent) || 10)) : 0,
      discount_amount: pendingDiscountCode ? (((Number(currentVariant().price) || 0) * getQty()) * (((DS && DS.percent) || 10) / 100)).toFixed(2) : '0.00',
      event_id_initiate: currentEvents.initiate,
      event_id_add_payment: currentEvents.addPayment,
      fbc: getCookie('_fbc'), fbp: getCookie('_fbp'),
      ttp: getCookie('_ttp'), ttclid: getCookie('ttclid') || (function(){ try { return (new URLSearchParams(location.search)).get('ttclid') || ''; } catch(e){ return ''; } })(),
      event_source_url: location.href,
    };

    // HLN-DUP-GUARD v1 — delivery-aware duplicate guard preflight (fail-open, 4s timeout).
    var _dupBody = JSON.stringify({ phone: (function(){ try { return cc + phoneDigits; } catch(e){ return ''; } })(), product_id: CFG.product.id });
    var _dupChk = fetch(CFG.endpoint + '/check?shop=' + encodeURIComponent(CFG.shop_domain), { method:'POST', headers:{'Content-Type':'application/json'}, body:_dupBody }).then(function(r){ return r.json(); }).catch(function(){ return { blocked:false }; });
    Promise.race([_dupChk, new Promise(function(rs){ setTimeout(function(){ rs({ blocked:false }); }, 4000); })]).then(function(_g){
      if (_g && _g.blocked) {
        try { submitBtn.disabled = false; } catch(e){}
        try { submitLabelEl.textContent = CFG.settings.submit_text; } catch(e){}
        try {
          var _at = modal.querySelector('.hlc-already-title'); var _ab = modal.querySelector('.hlc-already-body'); var _ar = modal.querySelector('.hlc-already-reassure');
          if (_at) _at.textContent = 'Έχετε ήδη μια ενεργή παραγγελία';
          if (_ab) _ab.textContent = 'Κάνατε πρόσφατα μια παραγγελία και το δέμα σας βρίσκεται καθ\' οδόν. Για βοήθεια επικοινωνήστε μαζί μας στο support@heliaon.gr';
          if (_ar) _ar.textContent = '';
        } catch(e){}
        try { alreadyShow(); } catch(e){}
        return;
      }
    // HLN-COD-N8N-ORDER v2 — cross-origin fetch to n8n; NO credentials so response can use ACAO:*.
    return fetch('https://2.28.61.115.sslip.io/webhook/heliaon-cod-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      mode: 'cors',
      keepalive: true
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j || !res.j.ok) {
          if (res.j && res.j.error === 'already_ordered') {
            var _e = new Error('already_ordered'); _e.__already409 = true; throw _e;
          }
          throw new Error(res.j && res.j.error || 'submit failed');
        }
        // Fire Purchase FIRST so the tracker beacon leaves the browser before navigation.
        firePixel('Purchase', res.j.order_name, { order_id: res.j.order_id });
        // HLN-CAPI-PURCHASE — server-side Purchase via CAPI (dedup: event_id = order_name). Fires before the 150ms redirect.
        try { trackServer('Purchase', res.j.order_name, { order_id: res.j.order_id }); } catch(e) {}
        try { pushHistory(CFG.product.id); } catch(e) {}
        writePending([]);
        selectedUpsells = {}; writeUpsells();
        // HLN-COD-THANK-YOU v2 — redirect to branded /pages/thank-you with product's brand color.
        // Same product→color rule as delivery emails: petrol for men's / tech products, oxblood otherwise.
        try {
          var _pt = ((CFG.product && CFG.product.title) || '').toLowerCase();
          var _ph = ((CFG.product && CFG.product.handle) || '').toLowerCase();
          var _petrolNeedles = ['celiér men','celier men','celier-men','celier-meski','celier meski','pulsego','knee','carbro','shaver','grooming','menzone'];
          var _isPetrol = _petrolNeedles.some(function(k){ return _pt.indexOf(k) !== -1 || _ph.indexOf(k) !== -1; });
          var _q = '?order=' + encodeURIComponent(res.j.order_name || '');
          if (_isPetrol) _q += '&color=petrol';
          if (res.j.order_status_url) _q += '&status_url=' + encodeURIComponent(res.j.order_status_url);
          setTimeout(function(){ window.location.assign('/pages/thank-you' + _q); }, 150);
        } catch(_) {
          form.hidden = true;
          successEl.hidden = false;
          orderNameEl.textContent = res.j.order_name || '';
        }
      })
      .catch(function (e) {
        if (e && e.__already409) { form.hidden = true; alreadyShow(); try { pushHistory(CFG.product.id); } catch(_){}; return; }
        console.warn('[hlc] submit err', e);
        submitBtn.disabled = false;
        submitLabelEl.textContent = CFG.settings.submit_text;
        var _errMap = {
          el: 'Η παραγγελία δεν καταχωρήθηκε. Παρακαλώ δοκιμάστε ξανά.',
          pl: 'Nie udało się złożyć zamówienia. Spróbuj ponownie.',
          ro: 'Comanda nu a putut fi plasată. Vă rugăm încercați din nou.',
          cz: 'Objednávku se nepodařilo odeslat. Zkuste to prosím znovu.',
          hu: 'A rendelést nem sikerült feladni. Kérjük, próbálja újra.'
        };
        alertInline(_errMap[CFG.language] || _errMap.el);
      });
    }); // HLN-DUP-GUARD close race
  });
  // HLN-COD-VALIDATION-TOAST v1 — floating red banner near the top of the modal panel,
  // auto-dismisses in 2.2s but also has an × button. Non-blocking; the inline red field-errors stay.
  function showValidationToast(msg) {
    try {
      var panel = modal && modal.querySelector('.hlc-panel');
      if (!panel) return;
      var old = panel.querySelector('.hlc-toast'); if (old) old.remove();
      var t = document.createElement('div');
      t.className = 'hlc-toast';
      t.setAttribute('role', 'alert');
      t.style.cssText = 'position:sticky;top:8px;z-index:5;margin:0 0 10px;padding:10px 34px 10px 12px;background:'+ACC+';color:#fff;border-radius:8px;font-size:14px;line-height:1.3;box-shadow:0 6px 20px rgba(0,0,0,.25);font-weight:600;animation:hlcToastIn .18s ease-out';
      t.textContent = msg;
      var x = document.createElement('button');
      x.type = 'button';
      x.setAttribute('aria-label', 'Close');
      x.textContent = '×';
      x.style.cssText = 'position:absolute;top:6px;right:8px;background:transparent;border:0;color:#fff;font-size:20px;line-height:1;cursor:pointer;padding:2px 6px';
      x.addEventListener('click', function(){ t.remove(); });
      t.appendChild(x);
      panel.insertBefore(t, panel.firstChild);
      setTimeout(function(){ try { t.remove(); } catch(_){} }, 2200);
    } catch(_){}
  }
  function alertInline(msg) {
    var wrap = document.createElement('div');
    wrap.style.cssText = 'color:#c0392b;background:#fff8f7;border:1px solid #c0392b;padding:8px 10px;border-radius:8px;margin:8px 0;font-size:13px';
    wrap.textContent = msg;
    form.insertBefore(wrap, submitBtn);
    setTimeout(function () { wrap.remove(); }, 4500);
  }

  // --- trigger hooks -----------------------------------------------------
  function findBuyButton() {
    var sels = CFG.trigger_selectors || [];
    for (var i = 0; i < sels.length; i++) {
      var b = document.querySelector(sels[i]);
      if (b) return b;
    }
    return null;
  }
  function hookButtons() {
    (CFG.trigger_selectors || []).forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.__hlcHooked) return;
        el.__hlcHooked = true;
        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          open();
        }, true);
      });
    });
  }

  // --- boot --------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.matches('[data-hlc-ds-accept]') || t.closest('[data-hlc-ds-accept]')) { e.preventDefault(); acceptDownsell(); return; }
    if (t.matches('[data-hlc-ds-refuse]') || t.closest('[data-hlc-ds-refuse]')) { e.preventDefault(); refuseDownsell(); return; }
    if (t.matches('[data-hlc-ds-jiggle]') || t.closest('[data-hlc-ds-jiggle]')) { e.preventDefault(); jiggleDownsell(); return; }
    if (t.matches('[data-hlc-close]') || t.closest('[data-hlc-close]')) {
      var isBackdrop = t.classList.contains('hlc-backdrop');
      if (isBackdrop && !CFG.settings.close_on_backdrop) {
        var panel = modal && modal.querySelector('.hlc-panel');
        if (panel) { panel.classList.remove('hlc-jiggle'); void panel.offsetWidth; panel.classList.add('hlc-jiggle'); }
        return;
      }
      close();
      return;
    }
    if (t.matches('[data-hlc-open-pending]') || t.closest('[data-hlc-open-pending]')) { open(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (downsellRoot && !downsellRoot.hidden) { jiggleDownsell(); return; }
    if (!root.hidden) {
      if (shouldShowDownsell()) { openDownsell(); return; }
      close({ force: true });
    }
  });
  window.addEventListener('popstate', function () {
    if (root.hidden) { window.__hlcHistPushed = false; return; }
    if (downsellRoot && !downsellRoot.hidden) { window.__hlcHistPushed = false; closeDownsell(); close({ force: true }); return; }
    if (shouldShowDownsell()) { try { history.pushState({ hlcCod: 1 }, ''); } catch (e) {} openDownsell(); return; }
    window.__hlcHistPushed = false; close({ force: true });
  });
  hookButtons();
  new MutationObserver(hookButtons).observe(document.documentElement, { childList: true, subtree: true });
  updateCartDot();
  updatePendingPill();

  window.HeliaonCOD = { open: open, close: close, addPending: addPending, pending: readPending, openWithDiscount: openWithDiscount };

  // Auto-inject cart-dot into the site header if snippet render is missing (fallback for Greek default header)
  function ensureCartDotEl() {
    if (document.getElementById('heliaon-cod-cart-dot')) return;
    var el = document.createElement('button');
    el.id = 'heliaon-cod-cart-dot';
    el.type = 'button';
    el.setAttribute('data-hlc-open-pending','');
    el.setAttribute('aria-label','Cart');
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:22px;height:22px;display:block"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M3 3h2l1 3"/></svg><span data-hlc-pending-count style="position:absolute;top:-4px;right:-4px;min-width:20px;height:20px;padding:0 5px;background:#1E1817;color:#fff;border:2px solid #fff;border-radius:999px;font-size:11px;font-weight:800;line-height:16px;text-align:center;box-sizing:border-box">0</span>';
    el.style.cssText = 'position:relative;display:inline-flex;width:44px;height:44px;padding:0;background:'+ACC+';color:#fff;border:0;border-radius:50%;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.18);align-items:center;justify-content:center;margin-left:20px';
    var target = document.querySelector('header .nav-right, header .header__row, header nav, header') || document.body;
    target.appendChild(el);
  }
  document.addEventListener('DOMContentLoaded', function(){ try { ensureCartDotEl(); updateCartDot(); } catch(e){} });

})();



